// 本地保存用户信息使用的key
export const TOKEN_KEY = 'XDM_USER_INFO'

// 邮箱正则
export const EMAIL_REG = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/